module.exports = {"cancel-subscription-reminders":{"confirmation-page-text":"Achte klant, jo ha oanjûn gjin herinnering mear ûntfange te wollen. Wy sille jo gjin e-mail mear stjoere as jo abonnemint ôfrint. Mei freonlike groetnis, Arriva Nederland"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/fy/subscriptions.json
// module id = 6MhF
// module chunks = 1